import React, { useEffect, useState } from 'react';

import { Pagination } from 'antd';
import Header from './header'


import style from '../scss/lx.scss'


function Lx() {

    return (
        <>
            <Header></Header>
            <div className="big"></div>
            <div className="box15"></div>
        </>
    )

}


export default Lx